export default __webpack_public_path__ + "static/media/blueAir.feeae8a8.mp4";